import { useQuery, useMutation, useQueryClient } from '@tanstack/vue-query'
import { api } from './client'
import type { components } from './types'

export type SettingsResponse = components['schemas']['SettingsResponse']
export type SettingsUpdate = components['schemas']['SettingsUpdate']

const SETTINGS_KEY = ['settings'] as const

export function useSettings() {
  return useQuery({
    queryKey: SETTINGS_KEY,
    queryFn: async () => {
      const res = await api.get<SettingsResponse>('/settings')
      return res.data
    },
    staleTime: 5 * 60_000,
  })
}

export function useUpdateSettings() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (body: SettingsUpdate) => {
      const res = await api.put<SettingsResponse>('/settings', body)
      return res.data
    },
    onSuccess: (data) => {
      qc.setQueryData(SETTINGS_KEY, data)
    },
  })
}
